import { IAdditionGroup } from '@core/models/shop.model';

export class AutoFillCartItemRulesAdditionsGroup {
  // ! It only works with additions group that have only one product, but it can be extended to work with multiple products
  static hasExclusiveAdditionInAdditionsGroup({
    additionGroup,
  }: {
    additionGroup: IAdditionGroup;
  }) {
    const isMinCountEqualToMaxCount = additionGroup.min_count === additionGroup.max_count;
    const hasOnlyOneAddition = additionGroup.items.length === 1;

    return isMinCountEqualToMaxCount && hasOnlyOneAddition;
  }

  static getAutoFilledAdditionIds(additionGroups: IAdditionGroup[]): string[] {
    return additionGroups.reduce((acc, additionGroup) => {
      if (this.hasExclusiveAdditionInAdditionsGroup({ additionGroup })) {
        const exclusiveAddition = additionGroup.items[0];
        if (exclusiveAddition.id) {
          const minCount = additionGroup.min_count || 1;
          const additionIds = Array(minCount).fill(exclusiveAddition.id);
          return [...acc, ...additionIds];
        }
      }
      return acc;
    }, [] as string[]);
  }
}
